<template>
    <div class="hello" style="font-family: STKaiTi">
<!--        <div class="cc108" >

        </div>-->
      <div class="record"  v-if="cut">
        <div style="text-align: center;padding-top: 60px" ><h3>欢迎来到修真世界</h3></div>
        <Form :model="formlogin" :label-width="68" style="margin-top: 60px;margin-left: 24px;width: 80%">
          <FormItem label="账号">
            <Input placeholder="请输入 6~20 位的帐号"  :border="false" v-model="formlogin.username" border="false" />
          </FormItem>
          <FormItem label="密码">
            <Input type="password" placeholder="请输入 6~20 位的密码" v-model="formlogin.password" border="false" style="background-color: transparent !important" />
          </FormItem>
        </Form>
<!--        <Button type="primary" long @click="enroll" style="margin-left: 53px;width: 74%" >登陆</Button>-->
        <button @click="enroll" style="margin-left: 53px;width: 74%">
          <span class="button_top"> 登 录 </span>
        </button>
        <div class="go-register" @click="cut = false" style="margin-left: 50px;width: 70%">
          或
          <a href="#">注册</a>
        </div>
      </div>
      <div class="record" shadow v-else>
        <Form :model="formRegister" :label-width="68" style="margin-top: 80px;margin-left: 24px;width: 77%">
          <FormItem label="账号" style="margin-bottom:8px !important; ">
            <Input placeholder="请输入 6~20 位的帐号"  v-model="formRegister.username" />
          </FormItem>
          <FormItem label="昵称" style="margin-bottom:8px !important; ">
            <Input placeholder="请输入 1~12 位的昵称" v-model="formRegister.nickname" />
          </FormItem>
          <FormItem label="密码" style="margin-bottom:8px !important; ">
            <Input placeholder="请输入 6~20 位的密码" v-model="formRegister.password" type="password" />
          </FormItem>
          <FormItem label="确认" style="margin-bottom:8px !important; ">
            <Input placeholder="请再输入一次密码" v-model="formRegister.confirmPassword" type="password" />
          </FormItem>
        </Form>
        <Button type="primary" long @click="register" style="background-color: #d3472e;margin-left: 53px;width: 74%">注册</Button>
        <div class="go-register" @click="cut = true" style="margin-left: 50px;width: 70%">
          或
          <a href="#" >登录</a>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            cut: true,
            selectChara: false,
            ruleValidate: {
                username: [
                    { required: true, message: "请输入用户名", trigger: "blur" },
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                    {
                        type: "string",
                        min: 6,
                        message: "请输入6位数以上的密码",
                        trigger: "blur",
                    },
                ],
            },
            formRegister: {
                username: undefined,
                password: undefined,
                nickname: undefined,
                confirmPassword: undefined,
            },
            formlogin: {
                username: undefined,
                password: undefined,
                confirmPassword: undefined,
            },
        };
    },
    methods: {
        enroll() {
            this.$http.post("gamepassport/login", this.formlogin).then((res) => {
                if (res.data.msg != "OK") {
                    console.log("看起来是账号密码错误了");
                    this.$Notice.warning({title:res.data.msg});
                    return;
                }
                if (res.data.data.userId) {
                    this.$Notice.success({title:"登录成功"});
                    sessionStorage.setItem("user",JSON.stringify(res.data.data));
                    this.setCookie("token", res.data.data.token, 3);
                    this.setCookie("userId", res.data.data.userId, 3);
                    //lim
                    localStorage.setItem("username", res.data.data.name)
                    localStorage.setItem("token", res.data.data.token)
                    localStorage.setItem("userId", res.data.data.userId)
                    document.cookie = "token=" + res.data.data.token + ";userId=" + res.data.data.userId ;
                    //this.setCookie("charaId", res.data.data.charaId, 3);
                    //this.$router.push({ name: "index" });
                    // console.log(res.data.data);
                    //返回角色列表 进行使用或创建操作

                    this.$router.push({ name: "selectChara" });
                }
            });
        },
        register() {
            if (this.formRegister.confirmPassword != this.formRegister.password) {
                this.$Notice.warning({title:"2次输入密码不同"});
                return;
            }

            this.$http.post("gamepassport/regist", this.formRegister).then((res) => {
                if (res.data.msg != "ok") {
                    this.$Notice.warning({title:res.data.msg});
                    return;
                }
            });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
    height: 100vh;
    background-image: url('../assets/loginPageDefBg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
}
* {
  font-family: '思源黑体', sans-serif ;
}
.cc108{
  width: 400px;
  height: 570px;
  top: 15%;
  left: 42%;
  position: absolute;
  background-color:rgb(255, 255, 255);
 /* background-image: url('../assets/denglukzq.png');*/
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
}
.record {
    width: 400px;
    height: 370px;
    position: absolute;
    left: 50%;
    top: 40%;
    margin-left: -200px;
    margin-top: -175px;
    background-color:rgb(255, 255, 255);
   /* background-image: url('../assets/denglukzq.png');*/
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
}
.record :global(.ivu-card-body) {
    padding: 24px 32px;
}
.go-register {
    margin-top: 8px;
}
.go-register a {
    color: #1890ff;
}
.form input {
    margin: 15px 0;
    height: 20px;
}
.form input:focus {
    box-shadow: 0 0 5px skyblue;
    border: 2px solid skyblue;
}
.button {
    width: 104px;
    margin: 20px auto 0;
}
.button button {
    border: 1px solid #333;
    background: #fff;
    outline: none;
    padding: 3px 6px;
    font-size: 14px;
}
.ivu-input .ivu-input-default{
  color: #de5431;
  background-color: transparent;
}
.button button:hover {
    cursor: pointer;
    box-shadow: 0 0 5px skyblue;
    border: 1px solid skyblue;
    transition: all 0.4s;
}
.center1 {
    text-align: center;
}
button {
  /* Variables */
  --button_radius: 0.75em;
  --button_color: #e8e8e8;
  --button_outline_color: #000000;
  font-size: 14px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  border-radius: var(--button_radius);
  background: var(--button_outline_color);
}

.button_top {
  display: block;
  box-sizing: border-box;
  border: 2px solid var(--button_outline_color);
  border-radius: var(--button_radius);
  padding: 0.75em 1.5em;
  background: var(--button_color);
  color: var(--button_outline_color);
  transform: translateY(-0.2em);
  transition: transform 0.1s ease;
}

button:hover .button_top {
  /* Pull the button upwards when hovered */
  transform: translateY(-0.33em);
}

button:active .button_top {
  /* Push the button downwards when pressed */
  transform: translateY(0);
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue